import React from "react";

import { Breadcrumbs } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import Brands from "./Brands";
import CarrierPage from "./Carrier";
import Currencies from "./Currencies";
import Languages from "./Languages";
import LeadSource from "./LeadSource";
import Measurements from "./Measurements";
import OrderType from "./OrderType";
import Preferences from "./Preference";
import SSCCGeneration from "./SSCCGeneration";
import Statuses from "./Statuses";
import useStyles from "./styles";
import TaskTypePage from "./TaskType";
import TolerancePorcentage from "./TolerancePercentage";
import { OperationsAppSettingsPage } from "./OperationsAppSettingsPage";
import { NetworkSettingsPage } from "./Network";
import { MilitarySettingsPage } from "./Military";

interface Props {
  tabName: string;
  permission?: {
    edit: boolean;
    create: boolean;
  };
}

enum Pages {
  PREFERENCES = "Preferences",
  CURRENCIES = "Currencies",
  LANGUAGES = "Languages",
  MEASUREMENTS = "Measurements",
  ORDER_TYPE = "Order Type",
  LEAD_SOURCE = "Lead Source",
  STATUS = "Statuses",
  TASK_TYPE = "Tasks Type",
  SSCC_GENERATION = "SSCC Generation",
  TOLERANCE_PORCENTAGE = "Tolerance Percentage",
  CARRIERS = "Carriers",
  OPERATIONS_APP_SETTINGS = "Operations app",
  BRANDS = "Brands",
  NETWORK = "Network",
  MILITARY = "Military",
}

export const GeneralSettingTab = ({ tabName, permission }: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const renderCurrentPage = () => {
    switch (tabName) {
      case Pages.PREFERENCES:
        return <Preferences permission={permission} />;
      case Pages.OPERATIONS_APP_SETTINGS:
        return <OperationsAppSettingsPage />;
      case Pages.CURRENCIES:
        return <Currencies permission={permission} />;
      case Pages.MEASUREMENTS:
        return <Measurements permission={permission} />;
      case Pages.ORDER_TYPE:
        return <OrderType permission={permission} />;
      case Pages.LEAD_SOURCE:
        return <LeadSource permission={permission} />;
      case Pages.STATUS:
        return <Statuses permission={permission} />;
      case Pages.TASK_TYPE:
        return <TaskTypePage permission={permission} />;
      case Pages.LANGUAGES:
        return <Languages permission={permission} />;
      case Pages.SSCC_GENERATION:
        return <SSCCGeneration permission={permission} />;
      case Pages.TOLERANCE_PORCENTAGE:
        return <TolerancePorcentage permission={permission} />;
      case Pages.CARRIERS:
        return <CarrierPage permission={permission} />;
      case Pages.BRANDS:
        return <Brands permission={permission} />;
      case Pages.NETWORK:
        return <NetworkSettingsPage />;
      case Pages.MILITARY:
        return <MilitarySettingsPage />;
      default:
        return <Preferences permission={permission} />;
    }
  };

  return (
    <div className={classes.generalWrapper}>
      {/* <header className="mb-4">
        <Breadcrumbs
          separator={<NavigateNext />}
          aria-label="breadcrumb"
          className={classes.headerBreadcrumbs}
        >
          <span className={classes.headerBreadcrumbsTitle}>{translate("configurations")}</span>
          <span className={classes.headerBreadcrumbsTitle}>{translate("general")}</span>
          <span
            data-cy="breadcrumbsSubTitle"
            className={`${classes.headerBreadcrumbsTitle} active`}
          >
            {tabName}
          </span>
        </Breadcrumbs>
      </header> */}
      {renderCurrentPage()}
    </div>
  );
};
